import { Injectable } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { XHttpService } from '@app/core/services/x-http.service';
@Injectable()
export class MatchService {

  constructor(
    private http:XHttpService,
    private ss: StateService
  ) { }

  bkRedir() {
    let param:any= {'lang':this.ss.language.code}
   return this.http.get('/v3.2/bookmakers-redir/index',this.http.httpParams(param))
}
}
